import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import ClubSearch from '../components/ClubSearch.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        let findBackground = this.el.dataset.background;

        const app = createApp({
            template: '<ClubSearch background="'+findBackground+'" />',
            components: {
                ClubSearch
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
        app.mount(self.el)
    }
}